
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/thjonusta/sms-gatt",
      function () {
        return require("private-next-pages/um/thjonusta/sms-gatt.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/thjonusta/sms-gatt"])
      });
    }
  